import { Box, Typography } from '@mui/material';
import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type ErrorProps = {
    message?: string;
    heading?: string | boolean;
    imageSize?: number;
};

export default function SttError({
    message,
    heading = true,
    imageSize = 100,
}: ErrorProps) {
    const { t } = useTranslation();

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: imageSize + 20,
                    height: imageSize + 20,
                    borderRadius: '50%',
                    border: '3px solid',
                    borderColor: 'error.main',
                    mb: 3,
                }}
            >
                <ErrorOutlineIcon
                    sx={{
                        fontSize: imageSize * 0.7,
                        color: 'error.main',
                    }}
                />
            </Box>

            {heading && (
                <Typography
                    variant="h5"
                    align="center"
                    gutterBottom
                    sx={{ fontWeight: 600, color: 'text.primary' }}
                >
                    {typeof heading === 'string' ? heading : t('generic.error')}
                </Typography>
            )}

            {message !== '' && (
                <Typography
                    variant="body1"
                    align="center"
                    sx={{ color: 'text.secondary', maxWidth: 400 }}
                >
                    {message || t('error.defaultMessage')}
                </Typography>
            )}
        </Box>
    );
}
